import type { LocaleBundle } from '../types.js'

export const ptBR: LocaleBundle = {
  code: 'pt-BR',
  name: 'Português (Brasil)',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Início',
    'common:search': 'Pesquisar',
    'common:loading': 'Carregando…',
    'common:save': 'Salvar',
    'common:cancel': 'Cancelar',
    'common:delete': 'Excluir',
    'common:create': 'Criar',
    'common:edit': 'Editar',
    'common:show': 'Visualizar',
    'common:back': 'Voltar',
    'common:noRecords': 'Nenhum registro encontrado.',
    'common:noRecordsHint': 'Comece criando um novo {resource}.',
    'common:noMatchingRecords': 'Nenhum registro corresponde aos seus filtros.',
    'common:clearFilters': 'Limpar filtros',
    'common:confirmDelete': 'Excluir este registro?',
    'common:confirmAction': 'Confirmar ação',
    'common:confirm': 'Confirmar',
    'common:perPage': 'Por página',
    'common:page': 'Página',
    'common:of': 'de',
    'common:total': 'Total',
    'auth:login': 'Entrar',
    'auth:logout': 'Sair',
    'auth:email': 'Email',
    'auth:password': 'Senha',
    'auth:loginFailed': 'Credenciais inválidas.',
    'errors:notFound': 'Não encontrado.',
    'errors:forbidden': 'Você não tem acesso a este recurso.',
    'errors:server': 'Algo deu errado. Tente novamente.',
    'common:resources': 'Recursos',
    'common:actions': 'Ações',
    'action:notFound': 'A ação "{action}" não está disponível neste recurso.',
    'action:componentMissing': 'Nenhum componente chamado "{component}" está registrado.',
    'action:componentMissingHint': 'Registre-o no ComponentLoader passado para <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'Falha ao carregar a ação.',
    'common:new': 'Novo',
    'common:rowsPerPage': 'Linhas por página',
    'common:filter': 'Filtrar {label}…',
    'validation:required': '{label} é obrigatório',
    'validation:invalidNumber': '{label} deve ser um número válido',
    'validation:invalidInteger': '{label} deve ser um inteiro',
    'validation:invalidEmail': '{label} deve ser um e-mail válido',
    'validation:invalidUrl': '{label} deve ser uma URL válida',
    'validation:invalidDate': '{label} deve ser uma data válida',
    'validation:invalidUuid': '{label} deve ser um UUID válido',
    'validation:tooShort': '{label} deve ter pelo menos {min} caracteres',
    'validation:tooLong': '{label} deve ter no máximo {max} caracteres',
    'validation:notInList': '{label} tem um valor inválido',
    'validation:emptySelection': 'Selecione pelo menos um valor para {label}',
    'toast:created': 'Criado com sucesso',
    'toast:saved': 'Salvo com sucesso',
    'toast:deleted': 'Excluído com sucesso',
    'toast:createFailed': 'Falha ao criar',
    'toast:saveFailed': 'Falha ao salvar',
    'toast:deleteFailed': 'Falha ao excluir',
    'toast:loadFailed': 'Falha ao carregar',
    'toast:validationFailed': 'Corrija os erros e tente novamente',
    'common:close': 'Fechar',
    'common:export': 'Exportar',
    'export:title': 'Exportar registros',
    'export:description': 'Baixar todos os registros correspondentes de {resource} em um único arquivo.',
    'export:csvHint': 'Valores separados por vírgula',
    'export:jsonHint': 'Array JSON estruturado',
    'export:downloading': 'Preparando download…',
    'export:progress': '{loaded} de {total} carregados…',
    'export:exported': '{count} registros exportados',
    'export:exportFailed': 'Falha ao exportar registros',
    'common:apply': 'Aplicar',
    'common:clear': 'Limpar',
    'common:filters': 'Filtros',
    'common:columns': 'Colunas',
    'common:toggleColumns': 'Mostrar colunas',
    'common:openMenu': 'Abrir menu',
    'common:refresh': 'Atualizar',
    'common:copy': 'Copiar',
    'common:copied': 'Copiado!',
    'common:applyFilters': 'Aplicar filtros',
    'common:clearAll': 'Limpar tudo',
    'common:any': 'Qualquer',
    'common:yes': 'Sim',
    'common:no': 'Não',
    'common:filterPlaceholder': 'Filtrar…',
    'common:loadFailed': 'Falha ao carregar: {error}',
    'common:theme': 'Tema',
    'common:language': 'Idioma',
    'common:toggleTheme': 'Alternar tema',
    'common:clearSelection': 'Limpar seleção',
    'common:searchPlaceholder': 'Buscar…',
    'home:searchResources': 'Buscar recursos…',
    'home:noMatchingResources': 'Nenhum recurso correspondente encontrado.',
    'globalSearch:title': 'Busca global',
    'globalSearch:description': 'Buscar em todos os recursos e registros.',
    'globalSearch:trigger': 'Buscar…',
    'globalSearch:placeholder': 'Buscar em todos os recursos…',
    'globalSearch:hint': 'Comece a digitar para buscar em todos os recursos.',
    'globalSearch:noResults': 'Nenhum registro correspondente encontrado.',
    'globalSearch:error': 'Falha na busca. Tente novamente.',
    'globalSearch:hotkey': 'Abrir busca global',
    'globalSearch:matchedIn': 'em {field}',
    'globalSearch:recent': 'Buscas recentes',
    'globalSearch:clearRecent': 'Limpar',
    'globalSearch:showAllIn': 'Mostrar tudo em {resource}',
    'common:pageOf': 'Página {page} de {total}',
    'common:firstPage': 'Primeira página',
    'common:previousPage': 'Página anterior',
    'common:nextPage': 'Próxima página',
    'common:lastPage': 'Última página',
    'common:recordsCount': '{count} registros',
    'common:selectedCount': '{count} selecionados',
    'common:selectRow': 'Selecionar linha',
    'common:selectAll': 'Selecionar tudo',
    'common:deleteSelected': 'Excluir selecionados',
    'common:bulkDeleteConfirm': 'Excluir {count} registros selecionados?',
    'toast:bulkDeleted': '{count} registros excluídos',
    'toast:bulkDeleteFailed': 'Falha ao excluir registros',
    'common:from': 'De',
    'common:to': 'Até',
    'common:sortBy': 'Ordenar por',
    'common:next': 'Próximo',
    'common:previous': 'Anterior',
    'common:relatedRecords': 'Registros relacionados',
    'common:viewAll': 'Ver todos',
    'common:noRelatedRecords': 'Sem registros relacionados.',
    'common:preview': 'Pré-visualizar',
    'common:download': 'Baixar',
    'common:openInNewTab': 'Abrir em nova aba',
    'common:format': 'Formatar',
    'common:invalidJson': 'JSON inválido',
    'common:showPassword': 'Mostrar senha',
    'common:hidePassword': 'Ocultar senha',
    'common:shortcutsHelp': 'Atalhos de teclado',
    'common:shortcutsEmpty': 'Não há atalhos disponíveis nesta tela.',
    'auth:title': 'Entrar',
    'auth:subtitle': 'Insira seu e-mail e senha para entrar',
    'auth:tagline': 'O painel de administração moderno para qualquer stack.',
    'auth:orContinueWith': 'Ou continuar com',
    'auth:continueWith': 'Continuar com {provider}',
    'common:chooseFile': 'Escolher arquivo',
    'common:chooseFiles': 'Escolher arquivos',
    'common:dragAndDrop': 'Arraste e solte ou',
    'common:chooseAFile': 'escolher um arquivo',
    'common:addMoreFiles': 'adicionar mais arquivos',
    'common:uploading': 'Enviando…',
    'common:uploadingFile': 'Enviando {name}…',
    'common:removeFile': 'Remover arquivo',
    'common:uploadFailed': 'Falha ao enviar',
    'common:dismiss': 'Fechar',
    'common:openCalendar': 'Abrir calendário',
    'common:time': 'Hora',
    'common:downloadFailed': 'Falha ao baixar',
    'richtext:bold': 'Negrito',
    'richtext:italic': 'Itálico',
    'richtext:strikethrough': 'Tachado',
    'richtext:inlineCode': 'Código inline',
    'richtext:heading': 'Título {level}',
    'richtext:bulletList': 'Lista com marcadores',
    'richtext:numberedList': 'Lista numerada',
    'richtext:blockquote': 'Citação em bloco',
    'richtext:horizontalRule': 'Linha horizontal',
    'richtext:insertLink': 'Inserir link',
    'richtext:undo': 'Desfazer',
    'richtext:redo': 'Refazer',
    'richtext:source': 'Fonte ({format})',
    'richtext:splitView': 'Visão dividida',
    'richtext:visualEditor': 'Editor visual',
    'richtext:fullscreen': 'Tela cheia',
    'richtext:exitFullscreen': 'Sair da tela cheia',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Salvando…',
    'common:done': 'Concluído',
    'settings:menuItem': 'Configurações',
    'settings:noSectionsConfigured': 'Nenhuma seção de configurações está disponível para esta instalação.',
    'settings:apiKeys.title': 'Chaves de API',
    'settings:apiKeys.description': 'Tokens de acesso programático à API de administração. Cada chave traz um conjunto de permissões que limita os recursos e ações que ela pode invocar.',
    'settings:apiKeys.actions.create': 'Nova chave',
    'settings:apiKeys.actions.edit': 'Editar',
    'settings:apiKeys.actions.revoke': 'Revogar',
    'settings:apiKeys.empty.title': 'Ainda não há chaves de API',
    'settings:apiKeys.empty.description': 'Crie a primeira chave para conceder acesso programático.',
    'settings:apiKeys.columns.name': 'Nome',
    'settings:apiKeys.columns.start': 'Prefixo',
    'settings:apiKeys.columns.permissions': 'Permissões',
    'settings:apiKeys.columns.expiresAt': 'Expira',
    'settings:apiKeys.columns.enabled': 'Ativa',
    'settings:apiKeys.columns.actions': 'Ações',
    'settings:apiKeys.lastUsed': 'Último uso {date}',
    'settings:apiKeys.expiresNever': 'Nunca',
    'settings:apiKeys.permissions.resource': 'Recurso',
    'settings:apiKeys.permissions.actions': 'Ações',
    'settings:apiKeys.permissions.selectAll': 'Selecionar tudo',
    'settings:apiKeys.permissions.clearAll': 'Limpar tudo',
    'settings:apiKeys.permissions.none': 'Sem permissões',
    'settings:apiKeys.permissions.summary': '{resources} recursos · {actions} ações',
    'settings:apiKeys.permissions.noResources': 'Nenhum recurso registrado.',
    'settings:apiKeys.permissions.selectAllResources': 'Selecionar todos os recursos e ações',
    'settings:apiKeys.permissions.clearAllResources': 'Limpar todos os recursos e ações',
    'settings:apiKeys.editor.titleCreate': 'Nova chave de API',
    'settings:apiKeys.editor.titleEdit': 'Editar chave de API',
    'settings:apiKeys.editor.description': 'Escolha um nome descritivo e conceda apenas os recursos e ações de que esta chave realmente precisa.',
    'settings:apiKeys.editor.name': 'Nome',
    'settings:apiKeys.editor.namePlaceholder': 'ex.: bot de deploy do CI',
    'settings:apiKeys.editor.expiresInDays': 'Expira em (dias)',
    'settings:apiKeys.editor.expiresPlaceholder': 'nunca',
    'settings:apiKeys.editor.expiresHint': 'Deixe em branco para não expirar. Máximo de 3650 dias.',
    'settings:apiKeys.editor.permissions': 'Permissões',
    'settings:apiKeys.editor.selectedActions': '{count} selecionadas',
    'settings:apiKeys.created.title': 'Chave de API criada',
    'settings:apiKeys.created.description': 'Copie a chave agora — ela não será exibida novamente.',
    'settings:apiKeys.created.warning': 'Esta é a única vez que você verá a chave completa. Guarde-a em local seguro.',
    'settings:apiKeys.created.reveal': 'Mostrar chave',
    'settings:apiKeys.created.hide': 'Ocultar chave',
    'settings:apiKeys.created.copy': 'Copiar',
    'settings:apiKeys.created.copied': 'Copiada',
    'settings:apiKeys.notice.revoked': 'Chave de API revogada',
    'settings:apiKeys.notice.updated': 'Chave de API atualizada',
    'settings:apiKeys.notice.copied': 'Copiada para a área de transferência',
    'settings:apiKeys.notice.copyFailed': 'Não foi possível copiar para a área de transferência',
    'settings:apiKeys.confirmRevoke.title': 'Revogar chave de API',
    'settings:apiKeys.confirmRevoke.description': 'Revogar "{name}"? Qualquer serviço que use esta chave deixará de funcionar imediatamente.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Painel',
    'chart:addChart': 'Adicionar gráfico',
    'chart:newChart': 'Novo gráfico',
    'chart:editChart': 'Editar gráfico',
    'chart:deleteChart': 'Remover gráfico',
    'chart:noCharts': 'Nenhum gráfico ainda',
    'chart:noChartsHint': 'Adicione um gráfico para começar a monitorar seus dados.',
    'chart:addGroup': 'Adicionar grupo',
    'chart:newGroup': 'Novo grupo',
    'chart:editGroup': 'Editar grupo',
    'chart:deleteGroup': 'Remover grupo',
    'chart:saveGroup': 'Salvar grupo',
    'chart:groupName': 'Nome do grupo',
    'chart:groupNamePlaceholder': 'ex. Métricas de vendas',
    'chart:groupNameRequired': 'O nome do grupo é obrigatório',
    'chart:groupOrder': 'Ordem do grupo',
    'chart:order': 'Ordem',
    'chart:orderHint': 'Valores menores aparecem primeiro.',
    'chart:moveToGroup': 'Mover para grupo',
    'chart:moveChart': 'Mover gráfico',
    'chart:moveGroup': 'Grupo',
    'chart:moveNoGroups': 'Nenhum grupo ainda.',
    'chart:moveNoGroupsHint': 'Crie um grupo primeiro para organizar seus gráficos.',
    'chart:deleteChartConfirm': 'Remover este gráfico?',
    'chart:deleteChartConfirmHint': 'Esta ação não pode ser desfeita.',
    'chart:deleteGroupConfirm': 'Remover este grupo?',
    'chart:deleteGroupConfirmHint': 'O grupo e os {count} gráfico(s) que ele contém serão excluídos permanentemente.',
    'chart:title': 'Título',
    'chart:titlePlaceholder': 'ex. Novos usuários por dia',
    'chart:untitled': 'Sem título',
    'chart:chartType': 'Tipo de gráfico',
    'chart:resource': 'Recurso',
    'chart:groupBy': 'Agrupar por',
    'chart:step': 'Passo',
    'chart:metric': 'Métrica',
    'chart:aggregateField': 'Campo de agregação',
    'chart:selectField': 'Selecionar campo…',
    'chart:saveChart': 'Salvar gráfico',
    'chart:typeLine': 'Linha',
    'chart:typeArea': 'Área',
    'chart:typeBar': 'Barras',
    'chart:typePie': 'Pizza',
    'chart:stepDay': 'Dia',
    'chart:stepWeek': 'Semana',
    'chart:stepMonth': 'Mês',
    'chart:stepYear': 'Ano',
    'chart:metricCount': 'Contagem',
    'chart:metricSum': 'Soma',
    'chart:metricAvg': 'Média',
    'chart:noData': 'Sem dados para o período selecionado',
    'chart:loadError': 'Falha ao carregar dados do gráfico',
    'chart:value': 'Valor',
    'dashboard:vis': 'Visualização',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Linha',
    'dashboard:visArea': 'Área',
    'dashboard:visBar': 'Barras',
    'dashboard:visPie': 'Pizza',
    'dashboard:metricCount': 'Contagem',
    'dashboard:metricSum': 'Soma',
    'dashboard:metricAvg': 'Média',
    'dashboard:metricMin': 'Mín',
    'dashboard:metricMax': 'Máx',
    'dashboard:builder.range': 'Período',
    'dashboard:builder.filters': 'Filtros',
    'dashboard:builder.filtersHint': 'Restringe o conjunto de dados antes da agregação. Marque um filtro para exibi-lo acima do gráfico.',
    'dashboard:builder.quickFilterHint': 'Exibir este filtro acima do gráfico no painel.',
    'dashboard:builder.quickFilterToggle': 'Expor {field} como filtro rápido',
    'dashboard:range.7d': '7d',
    'dashboard:range.30d': '30d',
    'dashboard:range.90d': '90d',
    'dashboard:range.1y': '1a',
    'dashboard:range.all': 'Tudo',
    'dashboard:range.custom': 'Personalizado',
    'dashboard:widget.previousPeriod': 'vs. período anterior',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Reduzir para metade da largura',
    'dashboard:widget.expand': 'Expandir para linha inteira',
    'dashboard:widget.toggleSql': 'Mostrar SQL',
    'dashboard:widget.unsupported': 'Gráficos ainda não são suportados para o seu banco de dados.',
    'dashboard:widget.truncatedWarning': 'Exibindo dados parciais — muitas linhas para agregar todo o intervalo.',
    'dashboard:widget.showAll': 'Mostrar tudo',
    'dashboard:widget.hideAll': 'Ocultar tudo',
    'dashboard:seriesTotal': 'Total',
    'dashboard:seriesOther': 'Outros',
    'dashboard:seriesNull': 'Vazio',
    'dashboard:builder.dateField': 'Campo de data',
    'dashboard:builder.dateFieldHint': 'O eixo X é agrupado por esta coluna de data.',
    'dashboard:builder.secondaryGroupBy': 'Detalhamento',
    'dashboard:builder.noBreakdown': 'Série única',
    'dashboard:builder.topN': 'Máx. séries',
    'dashboard:builder.width': 'Largura',
    'dashboard:width.half': 'Metade',
    'dashboard:width.full': 'Linha inteira',
    'dashboard:builder.comparePrevious': 'Comparar com o período anterior',
    'dashboard:builder.comparePreviousHint': 'Sobrepõe o período anterior de mesma duração como linha tracejada e mostra a variação ao lado do título.',
    'dashboard:builder.comparePreviousDisabled': 'Indisponível com um detalhamento.',
    'dashboard:builder.transform': 'Transformação de valores',
    'dashboard:builder.transformHint': 'Aplicada aos valores antes da exibição — p. ex., dividir por 100 para mostrar centavos como reais.',
    'dashboard:builder.transformAdd': 'Adicionar etapa',
    'dashboard:builder.transformRemove': 'Remover etapa',
    'dashboard:builder.opDivide': 'Dividir por',
    'dashboard:builder.opMultiply': 'Multiplicar por',
    'dashboard:builder.opAdd': 'Somar',
    'dashboard:builder.opSubtract': 'Subtrair',
    'dashboard:builder.format': 'Formato de valores',
    'dashboard:builder.formatStyle': 'Estilo',
    'dashboard:builder.formatNumber': 'Número',
    'dashboard:builder.formatCurrency': 'Moeda',
    'dashboard:builder.formatPercent': 'Porcentagem',
    'dashboard:builder.formatCurrencyCode': 'Código da moeda',
    'dashboard:builder.formatDecimals': 'Casas decimais',
    'dashboard:builder.formatCompact': 'Números compactos (12,5 mil)',
    'dashboard:builder.formatPrefix': 'Prefixo',
    'dashboard:builder.formatSuffix': 'Sufixo',
    'dashboard:builder.color': 'Cor da série',
    'dashboard:widget.previousSeries': '{label} (período anterior)',
    'dashboard:widget.editColors': 'Editar cores',
    'dashboard:widget.colorsTitle': 'Cores das séries',
    'dashboard:widget.colorCustom': 'Personalizado',
    'dashboard:widget.colorAuto': 'Automático',
    'dashboard:widget.colorPick': 'Escolher uma cor',
    'dashboard:builder.tabData': 'Dados',
    'dashboard:builder.tabDisplay': 'Exibição',
    'dashboard:builder.tabFilters': 'Filtros',
    'dashboard:builder.filtersEmpty': 'Este recurso não tem campos filtráveis.',
    'history:revisions': 'Revisões',
    'history:noRevisions': 'Ainda não há revisões',
    'history:loadError': 'Não foi possível carregar o histórico de alterações',
    'history:revert': 'Reverter',
    'history:confirmRevert': 'Reverter para esta revisão?',
    'history:revertSuccess': 'Revisão restaurada',
    'history:revertFailed': 'Não foi possível restaurar a revisão',
    'history:unknownUser': 'Usuário desconhecido',
    'history:changes': 'alterações',
    'history:compareTo': 'Comparar com',
    'history:storedDiff': 'Diff da alteração',
    'history:op.create': 'Criado',
    'history:op.update': 'Atualizado',
    'history:op.delete': 'Removido',
    'diff:added': 'Adicionado',
    'diff:changed': 'Alterado',
    'diff:removed': 'Removido',
    'diff:before': 'Antes',
    'diff:after': 'Depois',
    'diff:noChanges': 'Nenhuma alteração de campo registrada',
    'audit:title': 'Atividade',
    'audit:resource': 'Recurso',
    'audit:action': 'Ação',
    'audit:recordId': 'ID do registro',
    'audit:userId': 'ID do usuário',
    'audit:allResources': 'Todos os recursos',
    'audit:allActions': 'Todas as ações',
    'audit:noEvents': 'Ainda não há atividade',
    'audit:records': 'registros',
    'audit:loadError': 'Não foi possível carregar a atividade',
    'audit:by': 'por {user}',
    'audit:viewRecord': 'Ver registro',
    'audit:viewChanges': 'Ver alterações',
    'audit:hideChanges': 'Ocultar alterações',
    'audit:noDiff': 'Detalhes das alterações indisponíveis',
    'audit:loadDiffError': 'Falha ao carregar alterações',
    'audit:action.new': 'Registro criado',
    'audit:action.edit': 'Registro atualizado',
    'audit:action.delete': 'Registro removido',
    'audit:action.bulkDelete': 'Registros removidos',
    'audit:action.login': 'Login realizado',
    'audit:action.apiKeyCreate': 'Chave de API criada',
    'audit:action.apiKeyUpdate': 'Chave de API atualizada',
    'audit:action.apiKeyDelete': 'Chave de API excluída',
    'audit:virtualResource.auth': 'Autenticação',
    'audit:virtualResource.apiKeys': 'Chaves de API',
    'audit:prevPage': 'Anterior',
    'audit:nextPage': 'Próxima',
    'audit:dateRangePlaceholder': 'Selecionar período',
    'keyValue:noMatches': 'Sem correspondências — pressione Enter para manter "{value}".',
    'aiAssistant:queue.cancel': 'Remover da fila',
    'aiAssistant:title': 'Assistente IA',
    'aiAssistant:fab.label': 'Abrir assistente IA',
    'aiAssistant:fab.short': 'IA',
    'aiAssistant:description': 'Faça perguntas sobre registros, relacionamentos, relatórios e tendências de dados.',
    'aiAssistant:notConfigured.title': 'Assistente não configurado',
    'aiAssistant:notConfigured.description': 'Adicione a chave de API do OpenRouter nas configurações para ativar o assistente IA somente leitura.',
    'aiAssistant:notConfigured.openSettings': 'Abrir configurações',
    'aiAssistant:tryAsking': 'Experimente perguntar:',
    'aiAssistant:tryAsking.example1': 'Quais clientes têm mais publicações?',
    'aiAssistant:tryAsking.example2': 'Mostrar registros criados recentemente para um recurso.',
    'aiAssistant:tryAsking.example3': 'Explique relacionamentos entre registros específicos.',
    'aiAssistant:thinking': 'Pensando',
    'aiAssistant:thinkingProgress': 'Pensando ({progress}%)',
    'aiAssistant:input.placeholder': 'Pergunte sobre seus dados…',
    'aiAssistant:input.hint': 'Enter para enviar · Shift+Enter para nova linha',
    'aiAssistant:send': 'Enviar mensagem',
    'aiAssistant:newChat': 'Novo chat',
    'aiAssistant:history': 'Histórico de chats',
    'aiAssistant:history.empty': 'Nenhum chat anterior',
    'aiAssistant:noText': 'Aqui estão os registros relacionados encontrados:',
    'aiAssistant:fallback.noToolResult': 'A solicitação foi executada, mas o modelo não retornou uma resposta em texto. Tente refinar a pergunta ou habilite os logs de debug para inspecionar o resultado da ferramenta.',
    'aiAssistant:fallback.noRows': 'Nenhum registro foi encontrado para esta solicitação.',
    'aiAssistant:fallback.rowsFound': 'Linhas encontradas: {count}.',
    'aiAssistant:taskFailed': 'A tarefa do assistente IA falhou',
    'aiAssistant:settings.title': 'Assistente IA',
    'aiAssistant:settings.description': 'Configure o widget flutuante de chat IA, o modelo e o comportamento do assistente no servidor.',
    'aiAssistant:settings.enabled': 'Ativado',
    'aiAssistant:settings.disabled': 'Desativado',
    'aiAssistant:settings.configured': 'Configurado',
    'aiAssistant:settings.apiKeyRequired': 'Chave de API necessária',
    'aiAssistant:settings.readOnly': 'Somente leitura',
    'aiAssistant:settings.provider': 'Provedor: {provider}',
    'aiAssistant:settings.enableLabel': 'Ativar assistente',
    'aiAssistant:settings.enableHint': 'Controla a visibilidade do widget flutuante e do endpoint de chat.',
    'aiAssistant:settings.modelLabel': 'Modelo OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Chave de API OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Deixe em branco para manter a chave existente salva no servidor.',
    'aiAssistant:settings.systemPromptLabel': 'Substituição do prompt do sistema',
    'aiAssistant:settings.systemPromptPlaceholder': 'Instruções opcionais específicas do projeto para o assistente',
    'aiAssistant:settings.accessTitle': 'Modelo de acesso',
    'aiAssistant:settings.accessDescription': 'O assistente atual está limitado à inspeção somente leitura de registros por meio das ações de recursos de administração.',
    'aiAssistant:settings.futureToolsReady': 'Ferramentas futuras prontas',
    'aiAssistant:settings.save': 'Salvar configurações',
    'aiAssistant:settings.saving': 'Salvando…',
    'aiAssistant:settings.saved': 'Configurações do assistente IA salvas',
    'aiAssistant:settings.empty': 'Nenhuma configuração disponível.',
    'aiFill:button': 'Preencher com IA',
    'aiFill:dialogTitle': 'Preencher formulário a partir de uma foto',
    'aiFill:dialogDescription': 'Envie uma imagem — a IA extrairá os valores e preencherá o formulário.',
    'aiFill:fillButton': 'Reconhecer',
    'aiFill:processing': 'Reconhecendo imagem\u2026',
    'aiFill:success': '{count} campo(s) preenchido(s)',
    'aiFill:errorNoFields': 'Este recurso não tem campos preenchíveis pela IA.',
    'aiFill:errorGeneric': 'Falha no preenchimento pela IA: {message}',
    'aiFill:noValues': 'A IA não conseguiu extrair valores desta imagem.',
    'aiFill:applied': 'A IA preencheu {count} campo(s). Você pode desfazer abaixo.',
    'filter:op.co': 'Contém',
    'filter:op.nco': 'Não contém',
    'filter:op.sw': 'Começa com',
    'filter:op.ew': 'Termina com',
    'filter:op.eq': 'É igual a',
    'filter:op.neq': 'Não é igual a',
    'filter:op.empty': 'Está vazio',
    'filter:op.nempty': 'Não está vazio',
    'filter:op.in': 'É um de',
    'filter:op.gt': 'Maior que',
    'filter:op.lt': 'Menor que',
    'filter:op.between': 'Entre',
    'filter:searchValues': 'Buscar na lista…',
    'filter:selectAll': 'Selecionar tudo',
    'filter:noValues': 'Nenhum valor encontrado',
    'common:newRecord': 'Novo {name}',
    'common:editRecord': 'Editar {name} #{id}',
    'common:themeLight': 'Claro',
    'common:themeDark': 'Escuro',
    'common:themeSystem': 'Sistema',
    'common:ok': 'OK',
    'common:select': 'Selecionar…',
    'common:removeItem': 'Remover {title}',
    'common:nSelectedAddMore': '{count} selecionado(s) — adicionar mais',
    'common:pickRecords': 'Escolher registros',
    'common:managePickRecords': 'Gerenciar seleção ({count})',
    'common:pickRecordsFrom': 'Escolher de {name}',
    'common:draftRestored': 'Rascunho não salvo restaurado',
    'common:undoDraftRestore': 'Desfazer',
    'wizard:stepOf': 'Passo {current} de {total}',
    'wizard:products.step1': 'Informações básicas',
    'wizard:products.step2': 'Preços',
    'wizard:products.step3': 'Mídia e tags',
    'common:invalidValue': 'Valor inválido',
    'common:collapseSidebar': 'Recolher barra lateral',
    'common:expandSidebar': 'Expandir barra lateral',
    'common:toggleSidebar': 'Alternar barra lateral',
    'common:sidebarTitle': 'Barra lateral',
    'common:sidebarNavigation': 'Menu de navegação',
    'cache:title': 'Cache',
    'cache:description': 'Integridade do cache e desempenho por recurso nesta réplica.',
    'cache:load.error': 'Falha ao carregar métricas de cache',
    'cache:load.retry': 'Tentar novamente',
    'cache:reset.action': 'Redefinir métricas',
    'cache:reset.loading': 'Redefinindo métricas do cache…',
    'cache:reset.success': 'Métricas do cache redefinidas',
    'cache:reset.error': 'Não foi possível redefinir as métricas',
    'cache:metric.hitRate': 'Taxa de acertos',
    'cache:metric.requests': 'Leituras do cache',
    'cache:metric.avgCompute': 'Cálculo médio',
    'cache:metric.errors': 'Erros',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Tags em quarentena',
    'cache:quarantine.description': 'Estas tags ignoram o cache até a invalidação ser concluída.',
    'cache:invalidate.title': 'Invalidar cache do recurso',
    'cache:invalidate.description': 'Remove listas e registros do recurso em todas as réplicas configuradas.',
    'cache:invalidate.resource': 'Recurso',
    'cache:invalidate.action': 'Invalidar cache',
    'cache:invalidate.loading': 'Invalidando cache…',
    'cache:invalidate.success': 'Cache do recurso invalidado',
    'cache:invalidate.error': 'Não foi possível invalidar o cache do recurso',
    'cache:table.title': 'Métricas por namespace',
    'cache:table.empty': 'Ainda não há atividade de cache registrada.',
    'cache:instance': 'Réplica {id}',
    'cache:table.namespace': 'Namespace',
    'cache:table.resource': 'Recurso',
    'cache:table.hits': 'Acertos',
    'cache:table.misses': 'Erros',
    'cache:table.computes': 'Cálculos',
    'cache:table.coalesced': 'Agrupados',
    'cache:table.errors': 'Erros',
  },
}
